// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__26bb2","footer":"ModalUpdate_footer__1aMLs"};